import { render, staticRenderFns } from "./exercise.vue?vue&type=template&id=0af6ed0e&scoped=true&"
import script from "./exercise.vue?vue&type=script&lang=js&"
export * from "./exercise.vue?vue&type=script&lang=js&"
import style0 from "./exercise.vue?vue&type=style&index=0&id=0af6ed0e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af6ed0e",
  null
  
)

export default component.exports